import { makeStyles } from '@material-ui/core/styles';
import { alpha } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    background:
      theme.gradiants.panel ||
      'linear-gradient(to bottom, rgba(22,18,32,1) 0%, rgba(58,24,58,0.7) 53%)',
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    borderTopRightRadius: '25px',
    borderTopLeftRadius: '25px',
    paddingTop: '40px',
    paddingBottom: '20px',
    minHeight: '500px',
    maxHeight: '100%',
    boxSizing: 'border-box',
    overflow: 'hidden',
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    paddingBottom: '8px',
    paddingLeft: '8px',
    paddingRight: '8px',
    flexShrink: 0,
  },
  unitName: {
    fontSize: '24px',
    fontWeight: 400,
    lineHeight: '32.81px',
    color: '#FFFFFF',
    textAlign: 'center',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: 'calc(100% - 60px)',
  },
  scheduleButton: {
    color: '#9B8B9B',
    width: '50px',
    height: '50px',
    padding: 0,
    background: '#4b1c46'  
  },
  badge: {
    position: 'absolute',
    top: '-8px',
    right: '-8px',
    padding: '3px 7px',
    background: theme.palette.colors.white || '#fff',
    color: theme.palette.primary.main,
    fontSize: '12px',
    lineHeight: 'normal',
    borderRadius: '10px',
  },
  controlsList: {
    flex: 1,
    overflowY: 'auto',
    paddingBottom: '10px',
  },
  controlRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '6px',
  },
  controlLabel: {
    fontSize: '16px',
    fontWeight: 500,
    color: alpha('#fff', 0.7),
    flex: 1,
    paddingRight: '12px',
  },
  controlValue: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    flexShrink: 0,
    maxWidth: '55%',
    color: '#fff',
    // MUI Select on dark background
    '& .MuiInputBase-root': {
      minWidth: 140,
    },
    '& .MuiSelect-root': {
      color: '#fff',
      fontSize: '15px',
      paddingTop: 8,
      paddingBottom: 8,
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: alpha('#fff', 0.3),
    },
    '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: alpha('#fff', 0.6),
    },
    '& .MuiSvgIcon-root': {
      color: alpha('#fff', 0.7),
    },
    // InformationText value
    '& span': {
      color: '#fff',
    },
  },
  darkSelectField: {
    '& .MuiInputBase-input': {
      backgroundColor: 'transparent',
      color: '#fff',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: alpha('#fff', 0.3),
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: alpha('#fff', 0.6),
    },
    '& .MuiSvgIcon-root': {
      color: alpha('#fff', 0.7),
    },
  },
  scheduleActionRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '8px',
  },
  noTemplate: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '12px',
    backgroundColor: '#2a2a3e',
    borderRadius: '8px',
    minHeight: '400px',
    color: 'white',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));

export default useStyles;
